import { Component, ElementRef, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TimeSheetservice } from './time-stamp.service'
import { HttpClient } from '@angular/common/http';
import {
  AttendanceHeaderModel,
  BaseResponse,
  EmployeeAttendanceModel,
  EmployeeAttendanceModelDays,
  LeaveData,
  MismatchHoursDifferenceModel,
  projectNamesModel,
  TEHoursResponseModel,
  UserDetailsDTO
} from './DataModel';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { auto, end, start } from '@popperjs/core';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { WarningDialogComponent } from 'src/app/warning-dialog/warning-dialog.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { debug } from 'console';
import { MatDialog } from '@angular/material/dialog';
import { CommentsModel } from 'src/app/Models/commentsModel';
import { ToastrService } from 'ngx-toastr';
import { LinechartDialogComponent } from './linechart-dialog/linechart-dialog.component';
import { MatSelect, MatSelectModule, MatSelectTrigger } from '@angular/material/select';
import { some } from 'highcharts';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import * as XLSX from 'xlsx';
import { ChartModule } from 'primeng/chart';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-time-stamp',
  templateUrl: './time-stamp.component.html',
  styleUrls: ['./time-stamp.component.css']
})

export class TimeStampComponent {

  @ViewChild('chart5') chart5: ChartModule;
  public file: any
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });

  start_date: any = null;
  end_date: any = null;

  isManagerOrSuperAdmin: boolean;
  timeSheetForm !: FormGroup;
  formData: FormData;
  leaveData: LeaveData[];
  firstName: string;
  secondName: string;
  empId: string;
  roles: any;
  myForm: FormGroup;
  

  storeProjectManagerNames: any[] = [];
  storeProjectManagerNamesAll: any[] = [];
  storePointofContactsNames: any = [];
  storePointofContactsNamesAll: any = [];

  projectnames: Array<projectNamesModel> = [];
  projectnamesall: Array<projectNamesModel> = [];
  storeProjectName: any;

  uploading: boolean = false;

  isRequestCompleted = false;
  isRequestLoading = false;
  isUploading = false;  
  lastUpdatedDate: string;
  private ApiUrl = environment.apiUrl;

  projectInfos: any[] = [];
  userId: any;
  manager = new FormControl();
  project = new FormControl();

  filteredManagers: any[] = [];
  filteredProjects: any[] = [];
  alreadySelectedManager: boolean = false;
  showDropdownList: boolean = false;

  selectedOption: string = '';
  searchForm: FormGroup;

  searchTermControlManager = new FormControl();
  searchTermControlProject = new FormControl();
  searchTermControlEmployee = new FormControl();

  filteredOptions: UserDetailsDTO[] = [];
  allOptions: UserDetailsDTO[] = [];
  managerName: string = '';
  projectName: string = '';
  managerInvalid: boolean = false;
  managerId: any;
  selectedEmployeesLeaveData: MismatchHoursDifferenceModel[] = [];
  noDatainExcel: boolean = false;
  dataInExcel: boolean = false;
  @ViewChild('myInfoDialog') infoDialog = {} as TemplateRef<string>;
  @ViewChild('CommentsDialog') commentsDialog = {} as TemplateRef<string>;
  dialogRef: any;

  isAllManagerSelected: boolean;
  selectedManagers: any[] = [];
  empIdList: string[] = [];
  lastFilterManager: string = ""

  isAllProjectSelected: boolean;
  selectedProjects: any[] = [];
  lastFilterProject: string = ""

  isAllEmployeeSelected: boolean;
  selectedEmployees: any[] = [];
  lastFilterEmployee: string = "";
  commentToMail = '';
  Email: string = '';

  empAttendanceList: EmployeeAttendanceModel[] = []
  attendanceTableHeader: AttendanceHeaderModel[] = []
  allAttendanceTableHeader: AttendanceHeaderModel[] = []

  allMonths: string[] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  statusText: any = {
    'not_present_in_ps': "People strong data is not available in the file.",
    'present_in_ps': "Present in the file but no TE data found.",
    'match': "Data is correct.",
    'mismatch': "Data is incorrect.",
  }
  mismatchDates: any = [];
  montharr = [];

  selectedFileName: string | null = null;
  openFilters: { [key: string]: boolean } = {};
  openTableFilters: { [key: string]: boolean } = {};
  filterOptionsList = [];
  ListOfFilterOptions = [];
  ListOfEmpAttendance = [];
  selectedFilterOptions = [];
  isSelectedAll: boolean = false;
  AttedanceData: any[];
  currentOpenedFilterName = "";
  previouslyOpenedFilterName = "";
  empData: any[];
  listOfFilteredData: EmployeeAttendanceModel[];
  HolidayList: any[] = []
  differProjectCount: number = 0;
  actionCOunt: number = 0;
  timesheetAdmin: boolean = false;
  managerData: any[];
  submitClicked: boolean = false;
  groupedEmpAttendance: any = [];
  projectIds: any;
  pieChartData: any;
  pieChartOptions: any;
  isManager: boolean;
  isPMORole: boolean;
  empAttendanceListForPMO: EmployeeAttendanceModel[];
  uniqueProjectNamesArray: any[] = [];
  fileHistoryList = [];
  fileHistoryColumns = [
    'createdOn',
    'lastUpdatedOn',
    'statusNote'
  ];
  maxDate: any;
  dialogManagerComment: string = '';
  initialDialogComment: string = '';
  commentsForMultipleProjects: any = [];
  private lastAppliedRange: { start: Date | null; end: Date | null } = { start: null, end: null };
  totalProjectCount = 0;

  constructor(
    private http: HttpClient,
    private readonly formBuilder: FormBuilder,
    private service: TimeSheetservice,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private toster: ToastrService,
    private auth: AuthServiceService
  ) {

    this.myForm = this.formBuilder.group({
      projectPOCId: [[]],
      managerId: [null],
      projectId: [null]
    });

    this.storeProjectManagerNames = [];
    this.filteredManagers = this.storeProjectManagerNames;
    // this.fetchLastUpdatedDate();
    this.maxDate = moment().toDate(); // Set max date to today
    this.maxDate.setHours(23, 59, 59, 999);
  }

  ngOnInit(): void {
    this.buildTimeSheetForm();
    this.lastUpdated(); 
    this.service.GetHolidayList().subscribe(data => {
      this.HolidayList = data.data;
    })
    const today = new Date();
    this.start_date = moment(today).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    this.end_date = moment(today).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.range.setValue({
      start: this.start_date,
      end: this.end_date
    })
    this.service.getManagerCommentForEmployees().subscribe((res) => {
      if (res.data) {
        this.commentsForMultipleProjects = res.data;
      }
    });
    var currentEmployeeRole = this.auth.getRole();
    if (currentEmployeeRole.indexOf('PMORole') >= 0) {
      this.timesheetAdmin = true;
      this.formTable();
      // this.GetAttendanceTableHeader();
    }
    this.firstName = localStorage.getItem('firstName');
    this.secondName = localStorage.getItem('lastName');
    this.empId = localStorage.getItem('Id');
    this.roles = localStorage.getItem('role');
    if (this.roles) {
      let roles = this.roles.split(',');
      if (roles) {
        this.isManagerOrSuperAdmin = roles.some(x => x == 'SuperAdmin');
        this.isPMORole = roles.some(x => x == 'PMORole');
      }
    }
    this.managerName = this.firstName + ' ' + this.secondName + '(' + this.empId + ')';
    // this.getProjectManagersName();
    // this.service.getLeaveData().subscribe(data => {
    //   this.leaveData = data;
    // })

    this.searchForm = this.formBuilder.group({
      searchTerm: ['']
    });

    this.getManagersData();

    this.searchTermControlManager.valueChanges.pipe(
      startWith(''),
      map(userName => {
        this.storeProjectManagerNames = this.storeProjectManagerNamesAll.filter(x => x.name.toLowerCase().indexOf(userName.toLowerCase()) != -1);
      })
    ).subscribe();
    this.searchTermControlProject.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : this.lastFilterProject),
      map(searchText => {
        this.projectnames = this.projectnamesall.filter(x => x.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1)
      })
    ).subscribe();
    this.searchTermControlEmployee.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : this.lastFilterProject),
      map(searchText => {
        if (this.range.get('end').value)
          this.storePointofContactsNames = this.storePointofContactsNamesAll.filter(x => x.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1)
      })
    ).subscribe();
    this.getFileHistory();
  }

  updateTimesheetData() {
    const currentRange = this.range.value;
    const currentRangeString = JSON.stringify({
      start: currentRange.start.toISOString(),
      end: currentRange.end.toISOString()
    });
    const lastAppliedRangeString = JSON.stringify({
      start: this.lastAppliedRange.start ? this.lastAppliedRange.start.toISOString() : null,
      end: this.lastAppliedRange.end ? this.lastAppliedRange.end.toISOString() : null
    });
    if (currentRangeString !== lastAppliedRangeString) {
      this.service.getManagerCommentForEmployees().subscribe((res) => {
        this.commentsForMultipleProjects = res && res.data ? res.data : [];
        this.searchTermControlEmployee.enable();
        this.isAllEmployeeSelected = false;
        // this.attendanceTableHeader = [];
        this.montharr = []
        if (this.timesheetAdmin) {
          //this.attendanceTableHeader = [];
          this.ListOfEmpAttendance = []
        }
        this.getPOCByProjectIds("");
        this.differProjectCount = 0;
        this.actionCOunt = 0;
        this.lastAppliedRange = { ...currentRange } as { start: Date | null; end: Date | null };
      })
    } else if (currentRangeString === lastAppliedRangeString) {
      return;
    } else {
      this.searchTermControlEmployee.disable() // Reset value
      this.selectedEmployees = []
      this.storePointofContactsNames = []
      this.differProjectCount = 0;
      this.actionCOunt = 0;
    }
  }

  test(): void {
    this.empIdList = [];
    this.empIdList = this.selectedEmployees.map(att => att.EmpId);
    this.service.getCommentsList(this.empIdList).subscribe(
      (response: CommentsModel[]) => {
        const commentsList = response;
        console.log('API response:2', commentsList);
      },
      error => {
        console.error('API error:', error);
        // Handle the error here
      }
    );

    const mockResponse = [
      { empId: 1, managerId: 100112, comments: "Leave1", actionDate: new Date() },
      { empId: 2, managerId: 100112, comments: "Leave1", actionDate: new Date() },
      { empId: 3, managerId: 100112, comments: "Leave1", actionDate: new Date() },
    ];
    this.openDialog(mockResponse);
  }

  async getManagersData() {
    await this.service.getAllManagersName().subscribe(managers => {
      this.storeProjectManagerNamesAll = managers.data;
      this.storeProjectManagerNames = managers.data;
      if (this.storeProjectManagerNamesAll.length > 0 && !this.timesheetAdmin) {
        const managerData = this.storeProjectManagerNamesAll.filter(x => x.employeeId == localStorage.getItem('Id'));
        this.selectedManagers.push(managerData[0])
        this.getprojectNameByManagerIds()
      }
    });
  }
  openDialog(data: any): void {
    this.dialog.open(WarningDialogComponent, {
      width: '600px',
      data: { data } // Pass the mockResponse data to the dialog component
    });
  }

  applyFilter(colName, propKey) {
    this.ListOfEmpAttendance = this.empAttendanceList;
    var filterStringList = this.ListOfFilterOptions
      .filter(x => x.isSelected == true)
      .map(y => y.optionValue)
      .reduce((acc, val) => acc.concat(val), []);

    this.selectedFilterOptions
      .filter(x => x.Name == colName)
      .map(y => y.OptionsSelected = filterStringList);
    this.selectedFilterOptions.forEach(({ Name, OptionsSelected, PropKey }) => {
      if (Name && Array.isArray(OptionsSelected) && OptionsSelected.length > 0) {        
        this.ListOfEmpAttendance = this.ListOfEmpAttendance.filter(
          item => OptionsSelected.includes(item[PropKey])
        );
      }
    });
    if (colName === 'Delivery Manager') {
      this.filterOptionsList.filter(x => x.Name == "Project Name").map(value => {
        value.FilterOptions = [...new Set(this.ListOfEmpAttendance.map(x => x.ProjectName))].map(y => {
          return {
            optionValue: y,
            isSelected: false
          }
        })
      })
    }
    if (colName !== 'Employee Name') {
      this.filterOptionsList.filter(x => x.Name == "Employee Name").map(value => {
        value.FilterOptions = this.ListOfEmpAttendance.map(x => x.Name).map(y => {
          return {
            optionValue: y,
            isSelected: false
          }
        })
      })
    }
      this.ListOfEmpAttendance = this.dataMapping(this.ListOfEmpAttendance)
    // if (colName !== 'Employee Name') {  
    //   var checkSelectedAll = this.filterOptionsList.filter(x => x.Name == "Employee Name")
    //     .map(y => y.FilterOptions)
    //     .reduce((acc, val) => acc.concat(val), [])
    //     .every(z => z.isSelected == true);
    //   if (checkSelectedAll) {
    //     this.filterOptionsList.filter(x => x.Name == "Employee Name").map(y => y.IsSelectedAll = true);
    //   }
    //   else {
    //     this.filterOptionsList.filter(x => x.Name == "Employee Name").map(y => y.IsSelectedAll = false);
    //   }
    // }
    this.openFilters[colName] = !this.openFilters[colName]
  }

  clearFilter(columnName, propKey) {
    this.ListOfEmpAttendance = this.empAttendanceList;
    var filterStringList = this.ListOfFilterOptions.filter(x => x.isSelected == true).map(y => y.optionValue).reduce((acc, val) => acc.concat(val), []);
    filterStringList.forEach(value => {
      this.ListOfFilterOptions.filter(x => x.optionValue == value).map(y => y.isSelected = false);
    })
    this.selectedFilterOptions.filter(x => x.Name == columnName).map(y => y.OptionsSelected = []);
    if (columnName === 'Delivery Manager') {
      const projectNames = [...new Set(this.empAttendanceList.map(s => s.ProjectName))]
        .map((item) => {
        const selectedFilter = this.selectedFilterOptions.find(item => item.Name === 'Project Name')
        return {
          optionValue: item,
          isSelected: selectedFilter && selectedFilter.OptionsSelected && selectedFilter.OptionsSelected.length ? selectedFilter.OptionsSelected.includes(item) : false,
        }
      });
      this.filterOptionsList.filter(x => x.Name == "Project Name").map(y => y.FilterOptions = projectNames)
      const projectNameFilter = this.selectedFilterOptions.find(s => s.Name === 'Project Name');
      const data = this.ListOfEmpAttendance
        .filter(s => projectNameFilter && projectNameFilter.OptionsSelected && projectNameFilter.OptionsSelected.length ? projectNameFilter.OptionsSelected.includes(s[projectNameFilter.PropKey]) : true)
        .map(x => x.Name).map(y => {
          return {
            optionValue: y,
            isSelected: false
          }
        })
      this.filterOptionsList.filter(x => x.Name == "Employee Name").map(y => y.FilterOptions = data)
    }
    if (columnName === 'Project Name') {
      const deliveryFilter = this.selectedFilterOptions.find(s => s.Name === 'Delivery Manager');
        const data = this.ListOfEmpAttendance
          .filter(s => deliveryFilter && deliveryFilter.OptionsSelected && deliveryFilter.OptionsSelected.length ? deliveryFilter.OptionsSelected.includes(s[deliveryFilter.PropKey]) : true)
          .map(x => x.Name).map(y => {
            return {
              optionValue: y,
              isSelected: false
            }
          })
        this.filterOptionsList.filter(x => x.Name == "Employee Name").map(y => y.FilterOptions = data)
    }
    this.selectedFilterOptions.forEach(({ Name, OptionsSelected, PropKey }) => {
      if (Name && Array.isArray(OptionsSelected) && OptionsSelected.length > 0) {
        this.ListOfEmpAttendance = this.ListOfEmpAttendance.filter(item => OptionsSelected.includes(item[PropKey]));
        this.filterOptionsList.filter(x => x.Name == "Employee Name").forEach((x) => {
          x.FilterOptions.forEach((item) => {
            if (Name === 'Employee Name' && OptionsSelected.includes(item.optionValue)) {
              item.isSelected = true;
            }
          })
        })
      }
    });
    this.ListOfEmpAttendance = this.dataMapping(this.ListOfEmpAttendance)
    
    this.openFilters[columnName] = !this.openFilters[columnName]
  }

  isFilterActive(colName) {
    return this.selectedFilterOptions.filter(x => x.Name == colName).some(y => y && y.OptionsSelected && y.OptionsSelected.length > 0);
  }

  closeFilterPanel(column) {
    this.openFilters[column] = false;
    this.previouslyOpenedFilterName = column
  }

  toggleSelectAll(event, columnName) {
    if (event.checked) {
      this.filterOptionsList.filter(x => x.Name == columnName).map(y => y.IsSelectedAll = true);
      this.ListOfFilterOptions.forEach(x => {
        x.isSelected = true;
      });
    }
    else {
      this.filterOptionsList.filter(x => x.Name == columnName).map(y => y.IsSelectedAll = false);
      this.ListOfFilterOptions.forEach(x => {
        x.isSelected = false;
      });
    }
  }
  toggleSelectAllColumns(event: any) {
    if (event.checked) {
      this.allAttendanceTableHeader.forEach(x => {
        x.isSelected = true;
      });
    }
    else {
      this.allAttendanceTableHeader.forEach(x => {
        x.isSelected = false;
      });
    }
  }
  applyHeaders() {
    this.attendanceTableHeader = this.allAttendanceTableHeader;
    this.attendanceTableHeader = this.attendanceTableHeader.filter(x => x.isSelected == true);
    this.attendanceTableHeader.push(this.allAttendanceTableHeader[this.allAttendanceTableHeader.length - 1]);
    this.ListOfEmpAttendance = this.empAttendanceList;
    const propKeys = this.attendanceTableHeader.map(header => header.PropKey);
    propKeys.push("AttendanceData")
    const filteredEmp = this.ListOfEmpAttendance.map(empItem => {
      const listOfFilteredData: any = {};
      for (const key in empItem) {
        if (propKeys.includes(key)) {
          listOfFilteredData[key] = empItem[key];
        }
      }
      return listOfFilteredData;
    });
    this.ListOfEmpAttendance = filteredEmp;
    this.openTableFilters['Table'] = !this.openTableFilters['Table']
  }
  clearHeaderFilter() {
    const data = this.allAttendanceTableHeader.filter(x => x.Name).map(item => item.isSelected == true);
    this.attendanceTableHeader = this.allAttendanceTableHeader;
    this.ListOfEmpAttendance = this.empAttendanceList;
    const propKeys = this.attendanceTableHeader.map(header => header.PropKey);
    propKeys.push("AttendanceData")
    const filteredEmp = this.ListOfEmpAttendance.map(empItem => {
      const listOfFilteredData: any = {};
      for (const key in empItem) {
        if (propKeys.includes(key)) {
          listOfFilteredData[key] = empItem[key];
        }
      }
      return listOfFilteredData;
    });
    this.ListOfEmpAttendance = filteredEmp;
    this.openTableFilters['Table'] = !this.openTableFilters['Table']
    return data
  }
  checkSelectAll(colName): boolean {
    const data = this.filterOptionsList.filter(x => x.Name == colName).map(y => y.IsSelectedAll).reduce((acc, val) => acc.concat(val));;
    return data;
  }
  checkAllColumns(): boolean {
    const data = this.allAttendanceTableHeader.some(x => x.isSelected === false);
    return !data;
  }

  changeSelect(event, columnName) {
    if (!event.checked) {
      this.filterOptionsList.filter(x => x.Name == columnName).map(y => y.IsSelectedAll = false);
    }
    else {
      var allChecked = this.ListOfFilterOptions.every(x => x.isSelected == true);
      if (allChecked) {
        this.filterOptionsList.filter(x => x.Name == columnName).map(y => y.IsSelectedAll = true);
      }
      else {
        this.filterOptionsList.filter(x => x.Name == columnName).map(y => y.IsSelectedAll = false);
      }
    }
  }
  changeselectHeader(event: any, option: any) {
    console.log(option);
  }

  filterBlock(columnName) {
    this.openFilters[this.previouslyOpenedFilterName] = false;
    this.currentOpenedFilterName = columnName;
    this.openFilters[columnName] = !this.openFilters[columnName];
    this.ListOfFilterOptions = this.filterOptionsList
      .filter(x => x.Name == columnName)
      .map(y => y.FilterOptions)
      .reduce((acc, val) => acc.concat(val), []);

    this.previouslyOpenedFilterName = columnName;
  }

  filterHeaders() {
    this.openTableFilters['Table'] = !this.openFilters['Table'];
  }
  closeTableFilter() {
    this.openTableFilters['Table'] = false;
  }
  isFilterOpen(columnName): boolean {
    return this.openFilters[columnName];
  }

  searchOptions(searchTxt, name) {
    if (searchTxt != null) {
      this.ListOfFilterOptions = this.filterOptionsList.filter(x => x.Name == name)
        .map(y => y.FilterOptions).reduce((acc, val) => acc.concat(val), [])
        .filter(x => x.optionValue.toLowerCase().includes(searchTxt.toLowerCase()));
    }
    else {
      this.ListOfFilterOptions = this.filterOptionsList.filter(x => x.Name == name).map(y => y.FilterOptions).reduce((acc, val) => acc.concat(val), []);
    }
  }
  searchHeaders(searchTxt) {
    if (searchTxt != null)
      this.allAttendanceTableHeader = this.attendanceTableHeader
        .filter(item => item.Name.toLowerCase().includes(searchTxt.toLowerCase()));
  }

  getChildrenOnlyHeader() {
    var mainarr = []
    this.attendanceTableHeader.map(x => {
      if (x.Children != undefined) {
        if (x.Children.length > 0)
          mainarr.push(...x.Children)
      }
    })
    return mainarr
  }

  getChildrenData(emp: EmployeeAttendanceModel) {
    var mainarr = [];
    this.attendanceTableHeader.map(x => {
      if (x.Children != undefined && x.Children.length > 0) {
        const childArr = [];
        x.Children.map(y => {
          var info = emp.AttendanceData.find(z => z.Label === y.Label);
          if (info) {
            const cellData = {...y};
            cellData.Status = info.Status;
            cellData.StatusText = `${this.statusText[info.Status]}`;
            if (info.Status == 'mismatch') {
              // y.StatusText += `. PS Hours : ${info.PSHours} hours. TE Hours : ${info.TEHours} hours.`;
              // y.MismatchHours = this.getDifferenceInNumber(info.TEHours, info.PSHours);
              cellData.StatusText = `PS: ${info['PeopleStrongHours']} hrs.<br>T&E: ${info['TandEHours']} hrs.<br>Diff: ${info['mismatchHours']} hrs.`;
              emp.IsValid = false;
            }
            else if (info.Status == 'Weekly Off') {
              cellData.StatusText = 'Week Off';
            }
            else if (info.Status == 'Maternity Leave') {
              cellData.StatusText = 'Maternity Leave';
            }
            else if (info.Status == 'Paternity Leave') {
              cellData.StatusText = 'Paternity Leave';
            }
            childArr.push(cellData)
          }
        });
        mainarr.push(...childArr);
      }
    })
    return mainarr;
  }

  getDifferenceInNumber(a: number, b: number) { return Math.abs(a - b); }
  buildTimeSheetForm() {
    this.timeSheetForm = this.formBuilder.group({
      projectId: [null, [Validators.required]],
      projectPOCId: [null, [Validators.required]],
      managerId: [null, [Validators.required]],
      uploadfile: [null, [Validators.required]],
    });
    this.range = this.formBuilder.group({
      start: [null, [Validators.required]],
      end: [null, [Validators.required]]
    });
  }

  toggleCheckbox(head) {
    head.isSelected = !head.isSelected;
  }


  dateRange(startDate, endDate, steps = 6) {
    const dateArray = [];
    if (startDate && endDate) {
      let currentDate = new Date(startDate);
      while (currentDate <= new Date(endDate)) {
        const weekStart = new Date(currentDate);;
        let weekEnd = new Date(currentDate);
        // Use UTC date to prevent problems with time zones and DST
        weekEnd.setUTCDate(currentDate.getUTCDate() + steps);
        if (this.allMonths[weekEnd.getMonth()] != this.allMonths[currentDate.getMonth()]) {
          const EndDate = new Date(endDate);
          weekEnd = EndDate;
        }
        const daysInWeek = [];
        while (currentDate <= weekEnd) {
          const holiday = this.HolidayList.find(x => x.date == this.formatDate(currentDate));
          if (currentDate.getDay() != 6 && currentDate.getDay() != 0 && !holiday) {
            daysInWeek.push({
              date: this.formatDate(currentDate),
              checked: false,
              valid: true,
              psHours: null,
              teHours: null
            });
          }
          currentDate.setUTCDate(currentDate.getUTCDate() + 1);
        }
        dateArray.push({
          startDate: weekStart,
          endDate: weekEnd,
          days: daysInWeek,
          label: `${weekStart.toLocaleDateString('en-US', { day: '2-digit', month: '2-digit' })} - ${weekEnd.toLocaleDateString('en-US', { day: '2-digit', month: '2-digit' })}`
        });
      }
    }
    return dateArray;
  }



  lastUpdated() {
    this.http.get(this.ApiUrl + 'Timesheet/GetAttendanceLastUpdatedDate').subscribe(
      (response: any) => {
        console.log('API call successful', response);
        const date = response.message.split(" ");
        this.lastUpdatedDate = date && date[0] ? date[0] : response.message;
      },
      error => {
        console.error('API call failed', error);
      }
    );
  }

  getFileHistory() {
    this.service.getFileStatus().subscribe((res) => {
      if (res && res.succeeded) {
        this.fileHistoryList = res.data.sort((a, b) => {
          const dateA = new Date(a.createdOn);
          const dateB = new Date(b.createdOn);
          return dateB.getTime() - dateA.getTime();
        });
      }
    });
  }
  
  reloadPage() {
    window.location.reload();
  }  
    
  
   requestTimesheet() {
    this.isUploading = true;
    // const requestTimesheetButton = document.querySelector('.request-timesheet-button') as HTMLButtonElement; 
    // requestTimesheetButton.classList.add('uploading');
    this.isRequestLoading = true;
    const loggedInUserEmail = this.getLoggedInUserEmail();
    const HREmail = 'hrishikesh.kaveti@innovasolutions.com';
  
    console.log('Logged in user email:', loggedInUserEmail);
    console.log('HR email:', HREmail);
  
    if (!loggedInUserEmail || !HREmail) {
      console.error('Email addresses cannot be null or undefined.');
      this.isUploading = false;
      this.isRequestLoading = false;
      // requestTimesheetButton.classList.remove('uploading');
      return;
    }
  
    const payload = {
      UserEmail: loggedInUserEmail,
      HREmail: HREmail
    };
  
    console.log('Payload:', payload);
  
    this.http.post(this.ApiUrl + 'Timesheet/request-upload', payload).subscribe(response => {
      console.log('API response:', response);
      this.isUploading = false;
      this.isRequestCompleted = true;
      this.isRequestLoading = true;
      // requestTimesheetButton.classList.remove('uploading');
      // requestTimesheetButton.disabled = true;
      // requestTimesheetButton.classList.add('success');
      this.toster.info('People Strong Timesheet Data Requested');
    }, error => {
      console.error('API error:', error);
      this.isUploading = false;
      this.isRequestLoading = false;
      // requestTimesheetButton.classList.remove('uploading');
      this.toster.error('Failed to Request Data');
    });
  }
  
  getLoggedInUserEmail(): string {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const storage = isLocal ? localStorage : sessionStorage;
    const userEmail = storage.getItem('email');
    console.log('Logged in user email:', userEmail);
    return userEmail ? userEmail : '';
  }
  
  
  

fetchLastUpdatedDate() {
  // this.http.get('your-api-endpoint').subscribe((data: any) => {
  //   this.lastUpdatedDate = data.lastUpdated; 
  // });
}
 
  isAllVisibleChecked(_type: string) {
    switch (_type) {
      case "manager":
        let manageralltrue = this.isAllManagerSelected && (this.storeProjectManagerNames.length == this.storeProjectManagerNames.filter(x => x.selected == true).length)
        this.isAllManagerSelected = manageralltrue;
        return manageralltrue;
      case "project":
        let projectalltrue = this.isAllProjectSelected && (this.projectnames.length == this.projectnamesall.filter(x => x.selected == true).length)
        this.isAllProjectSelected = projectalltrue;
        return projectalltrue;
      case "employee":
        let employeealltrue = this.isAllEmployeeSelected && (this.storePointofContactsNames.length == this.storePointofContactsNames.filter(x => x.selected == true).length)
        this.isAllEmployeeSelected = employeealltrue;
        return employeealltrue;
    }
    return false;
  }


  toggleSelectAllManagers() {
    this.isAllManagerSelected = !this.isAllManagerSelected;
    let len = this.storeProjectManagerNames.length;
    this.storeProjectManagerNamesAll.forEach(x => {
      x.selected = false
    })
    for (var i = 0; i < len; i++) {
      this.storeProjectManagerNames[i].selected = this.isAllManagerSelected;
    }
    if (this.isAllManagerSelected) {
      this.selectedManagers = this.storeProjectManagerNames;
    } else {
      this.selectedManagers = [];
    }
    this.getprojectNameByManagerIds()
    this.searchTermControlManager.reset('')
    if (this.storeProjectManagerNamesAll.length == this.selectedManagers.length)
      this.isAllManagerSelected = true;
    else
      this.isAllManagerSelected = false;
  }

  toggleSelectionManager(item: any) {
    item.selected = !item.selected;
    if (item.selected) {
      this.selectedManagers.push(item);
    } else {
      this.selectedManagers = this.selectedManagers.filter(x => x.employeeId != item.employeeId)
      this.isAllManagerSelected = false;
    }
    this.selectedProjects = []
    this.isAllProjectSelected = false
    this.selectedEmployees = []
    this.isAllEmployeeSelected = false
    this.getprojectNameByManagerIds()
    this.searchTermControlManager.reset('')
    if (this.storeProjectManagerNamesAll.length == this.selectedManagers.length)
      this.isAllManagerSelected = true;
    else
      this.isAllManagerSelected = false;
  }
  removeManager(manager: any): void {
    this.selectedManagers = this.selectedManagers.filter(m => m.employeeId !== manager.employeeId);
    this.storeProjectManagerNamesAll.forEach(item => {
      if (item.employeeId === manager.employeeId) {
          item.selected = false;
      }
    });
    this.isAllManagerSelected = false;
  }
  toggleSelectAllProjects() {
    this.isAllProjectSelected = !this.isAllProjectSelected;
    let len = this.projectnames.length;
    this.projectnamesall.forEach(x => {
      x.selected = false
    })
    for (var i = 0; i < len; i++) {
      this.projectnames[i].selected = this.isAllProjectSelected;
    }
    if (this.isAllProjectSelected) {
      this.selectedProjects = this.projectnames;
    } else {
      this.selectedProjects = [];
    }
    if (this.selectedManagers.length == 0)
      this.selectedProjects = []
    this.setDateRangeEnableDisabled()
    this.searchTermControlProject.reset('')

  }

  toggleSelectionProject(item: any) {
    item.selected = !item.selected;
    if (item.selected) {
      this.selectedProjects.push(item);
    } else {
      this.selectedProjects = this.selectedProjects.filter(x => x.id != item.id)
      this.isAllProjectSelected = false;
    }
    if (this.selectedManagers.length == 0)
      this.selectedProjects = []
    this.setDateRangeEnableDisabled()
    this.searchTermControlProject.reset('')
  }

  async toggleSelectAllEmployees() {
    this.isAllEmployeeSelected = !this.isAllEmployeeSelected;
    let len = this.storePointofContactsNames.length;
    this.storePointofContactsNamesAll.forEach(x => {
      x.selected = false
    })
    for (var i = 0; i < len; i++) {
      this.storePointofContactsNames[i].selected = this.isAllEmployeeSelected;
    }
    if (this.isAllEmployeeSelected) {
      this.selectedEmployees = this.storePointofContactsNames;
    } else {
      this.selectedEmployees = [];
    }
    if (this.selectedEmployees.length > 0) {
      // if(this.attendanceTableHeader.length == 0 ){
      this.formTable()
      // }
      await this.service.getAttendanceData(
        this.selectedEmployees.map(x => x.id.toString()),
        this.formatDate(new Date(this.start_date)),
        this.formatDate(new Date(this.end_date))
      ).subscribe(data => {
        this.AttedanceData = data.data;
        // if (this.AttedanceData.length > 0) {
          this.uploadExcelFile()
        // }
      });

    }

    this.searchTermControlEmployee.reset('')
  }
  getdataforpiechart() {
      let pieChartData = {
        datasets: [{
          data: [],
          backgroundColor: [],
        }],
        labels: []
      };

      this.pieChartOptions = {
        plugins: {
          legend: {
            position: 'right',
            align: 'bottom',
            labels: {
              usePointStyle: false,
              color: 'Black'
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      };
      const inValidEmployees = this.empAttendanceList.filter(x => x.IsValid == false);
      const labels = [];
      const data = [];
      const projectDifferences = {};
      inValidEmployees.forEach(employee => {
          let totalDifference = 0;
          employee.AttendanceData.forEach(attendance => {
            if (attendance.Status === "mismatch") {
                if (attendance.PSHours !== null && attendance.TEHours !== null){
                const teHours = attendance.TEHours ;
                const psHours = attendance.PSHours ;
                totalDifference += Math.abs(teHours - psHours);
              }                                 
            }
          });
          const projectName = employee.ProjectName || "Unknown Project";
          if (projectDifferences[projectName]) {
            projectDifferences[projectName] += totalDifference;
          } else {
            projectDifferences[projectName] = totalDifference;
          }
      });
      for (const [project, totalDiff] of Object.entries(projectDifferences)) {
        labels.push(project);
        data.push(totalDiff);
      }
      pieChartData = {
        datasets: [{
          data: data,
          backgroundColor: this.generateColors(labels.length),
        }],
        labels: labels
      };
      this.pieChartData = pieChartData;
  }
  submitButton() {
    this.submitClicked = true;
    if (this.submitClicked) {
      this.toggleSelectAllEmployees()
    }
  }
  getpiechartdataforPMORole() {
      let pieChartData = {
        datasets: [{
          data: [],
          backgroundColor: [],
        }],
        labels: []
      };
      this.pieChartOptions = {
        plugins: {
          legend: {
            position: 'right',
            align: 'bottom',
            labels: {
              usePointStyle: false,
              color: 'Black'
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      };
      const uniqueRecords = new Map();
      this.empAttendanceListForPMO.forEach(record => {
      const key = `${record.Name}-${record.ManagerId}`;
      if (!uniqueRecords.has(key)) {
        uniqueRecords.set(key, record);}});
      this.empAttendanceListForPMO.length = 0; 
      this.empAttendanceListForPMO.push(...Array.from(uniqueRecords.values()));
      const inValidEmployees = this.empAttendanceListForPMO.filter(x => x.IsValid == false);
      const labels = [];
      const data = [];
      const managerDifferences = {};
      inValidEmployees.forEach(employee => {
        if (!employee.IsValid) {
          let totalDifference = 0;
          employee.AttendanceData.forEach(attendance => {
            if (attendance.Status === "mismatch") {
                if (attendance.PSHours !== null && attendance.TEHours !== null){
                const teHours = attendance.TEHours ;
                const psHours = attendance.PSHours ;
                totalDifference += Math.abs(teHours - psHours);
              }                                 
            }
          });
          const managerId = employee.ManagerId;
          const manager = this.storeProjectManagerNames.find(m => m.employeeId === managerId);
          const managerName = manager ? manager.name : "Unknown Manager";
          if (managerDifferences[managerName]) {
            managerDifferences[managerName] += totalDifference;
          } else {
            managerDifferences[managerName] = totalDifference;
          }
        }
      });
      for (const [manager, totalDiff] of Object.entries(managerDifferences)) {
        labels.push(manager);
        data.push(totalDiff);
      }
      pieChartData = {
        datasets: [{
          data: data,
          backgroundColor: this.generateColors(labels.length),
        }],
        labels: labels
      };
      this.pieChartData = pieChartData;
  }
  generateColors(count: number): string[] {
    const colors = [
      '#7DBE7D', '#ffce61', '#ff6e6e', '#ff9f40', '#4bc0c0',
      '#9966ff', '#ff66b2', '#ffcc00', '#c4e17f', '#ff6f61',
      '#6a1b9a', '#d32f2f', '#1976d2', '#388e3c', '#0288d1',
      '#f57c00', '#c2185b', '#7b1fa2', '#fbc02d', '#0288d1'
    ];
    return colors.slice(0, count);
  }
  toggleSelectionEmployee(item: any) {
    item.selected = !item.selected;
    if (item.selected) {
      this.selectedEmployees.push(item);
    } else {
      this.selectedEmployees = this.selectedEmployees.filter(x => x.id != item.id)
      this.isAllEmployeeSelected = false;
    }
    if (this.selectedEmployees.length > 0)
      this.formTable()
    this.searchTermControlEmployee.reset('')

  }

  setDateRangeEnableDisabled() {
    if (this.selectedProjects.length > 0 && this.selectedManagers.length > 0) {
      this.range.get('start').enable();
      this.range.get('end').enable();
    }
    else {
      this.range.get('start').disable();
      this.range.get('end').disable();
    }
  }

  formTable() {
    var data = this.dateRange(this.range.get('start').value, this.range.get('end').value)
    data.forEach(x => {
      var PropKey = this.allMonths[x.startDate.getMonth()] + x.startDate.getFullYear()
      var Name = this.allMonths[x.startDate.getMonth()] + " " + x.startDate.getFullYear()
      if (!this.montharr.find(x => x.PropKey == PropKey) && this.montharr.length === 0)
        this.montharr.push({
          Name: Name,
          PropKey: PropKey,
          FilterStatus: false,
          DropDownValues: [],
          Children: []
        })
      this.montharr.map(y => {
          y.Children.push({
            Month: this.allMonths[x.startDate.getMonth()],
            Day: x.days,
            Text: null,
            Label: x.label,
            Hours: x.days.length * 8,
          });
      });
    })
    this.attendanceTableHeader = []
    this.attendanceTableHeader = [
      {
        Name: "Delivery Manager",
        PropKey: "DeliveryManager",
        FilterStatus: true,
        DropDownValues: [],
        isSelected: false
      },
      {
        Name: "Project Name",
        PropKey: "ProjectName",
        FilterStatus: true,
        DropDownValues: [],
        isSelected: false
      },
      // {
      //   Name: "Customer Name",
      //   PropKey: "CustomerName",
      //   FilterStatus:true,
      //   DropDownValues:[],
      //   isSelected:false
      // },
      // {
      //   Name: "Portfolio Leader",
      //   PropKey: "PortfolioLeader",
      //   FilterStatus:true,
      //   DropDownValues:[],
      //   isSelected:false
      // },

      // {
      //   Name: "Engineering Manager",
      //   PropKey: "EngineeringManager",
      //   FilterStatus:true,
      //   DropDownValues:[],
      //   isSelected:false
      // },
      // {
      //   Name: "Client Partner",
      //   PropKey: "ClientPartner",
      //   FilterStatus:true,
      //   DropDownValues:[],
      //   isSelected:false
      // },

      // {
      //   Name: "Employee Id",
      //   PropKey: "EmpId",
      //   FilterStatus: true,
      //   DropDownValues: [],
      //   isSelected: false
      // }, 
      {
        Name: "Employee Name",
        PropKey: "Name",
        FilterStatus: true,
        DropDownValues: [],
        isSelected: false
      }
    ];
    this.attendanceTableHeader.push(...this.montharr)

    this.attendanceTableHeader.forEach(x => {
      this.openFilters[x.Name] = false;
    });
    this.openTableFilters['Table'] = false;
    this.attendanceTableHeader.forEach(x => {
      var columnList = [{
        Name: x.Name,
        PropKey: x.PropKey,
        OptionsSelected: [],
      }]
      this.selectedFilterOptions.push(...columnList);
    })
    this.attendanceTableHeader = Object.assign(this.attendanceTableHeader);
  }

  GetAttendanceTableHeader() {
    this.attendanceTableHeader = []
    this.attendanceTableHeader = [
      {
        Name: "Delivery Manager",
        PropKey: "DeliveryManager",
        FilterStatus: true,
        DropDownValues: [...new Set(this.empAttendanceList.map(x => x.DeliveryManager))],
        isSelected: false
      },
      {
        Name: "Project Name",
        PropKey: "ProjectName",
        FilterStatus: true,
        DropDownValues: [...new Set(this.empAttendanceList.map(x => x.ProjectName))],
        isSelected: false
      },
      // {
      //   Name: "Customer Name",
      //   PropKey: "CustomerName",
      //   FilterStatus:true,
      //   DropDownValues:[...new Set(this.empAttendanceList.map(x=>x.CustomerName))],
      //   isSelected:false
      // },
      // {
      //   Name: "Portfolio Leader",
      //   PropKey: "PortfolioLeader",
      //   FilterStatus:true,
      //   DropDownValues:[...new Set(this.empAttendanceList.map(x=>x.PortfolioLeader))],
      //   isSelected:false
      // },

      // {
      //   Name: "Engineering Manager",
      //   PropKey: "EngineeringManager",
      //   FilterStatus:true,
      //   DropDownValues:[...new Set(this.empAttendanceList.map(x=>x.EngineeringManager))],
      //   isSelected:false
      // },
      // {
      //   Name: "Client Partner",
      //   PropKey: "ClientPartner",
      //   FilterStatus:true,
      //   DropDownValues:[...new Set(this.empAttendanceList.map(x=>x.ClientPartner))],
      //   isSelected:false
      // },
      // {
      //   Name: "Employee Id",
      //   PropKey: "EmpId",
      //   FilterStatus: true,
      //   DropDownValues: [...new Set(this.empAttendanceList.map(x=>x.EmpId))],
      //   isSelected: false
      // }, 

      {
        Name: "Employee Name",
        PropKey: "Name",
        FilterStatus: true,
        DropDownValues: [...new Set(this.empAttendanceList.map(x => x.Name))],
        isSelected: false
      }
    ];
    this.attendanceTableHeader.push(...this.montharr);
    this.allAttendanceTableHeader = this.attendanceTableHeader;
    this.attendanceTableHeader = Object.assign(this.attendanceTableHeader);
  }

  formEmptyAttendanceData() {
    var data = this.dateRange(this.range.get('start').value, this.range.get('end').value)
    return data.map(x => {
      return  <any>{
        Month: this.allMonths[x.startDate.getMonth()],
        MonthKey: x.startDate.getMonth(),
        Days: x.days,
        Label: x.label,
        Year: x.startDate.getFullYear(),
        Status: "not_present_in_ps",
      }
    })
  }

  toDateObject(date: string) {
    return new Date(this.formatDate1(date))
  }

  compareDatesOnly(date1: Date, date2: Date) {
    return (
      date1.getDate() == date2.getDate() &&
      date1.getFullYear() == date2.getFullYear() &&
      date1.getMonth() == date2.getMonth()
    );
  }

  buildempAttendanceList() {
    this.empAttendanceList = [];
    this.empAttendanceList.push(...this.selectedEmployees.map(x => {
      const project = this.projectnames.find(y => y.id == x.parentId && y.managerId == x.managerId);
      const managerComments = this.commentsForMultipleProjects.find((comment) => comment.parentId === x.id);
      return <EmployeeAttendanceModel>{
        DeliveryManager: project?.deliveryManager,
        ProjectName: project?.name,
        CustomerName: project?.customerName,
        PortfolioLeader: project?.portfolioLeader,
        ClientPartner: project?.clientPartner,
        EngineeringManager: project?.engineeringManager,
        EmpId: x.id,
        ManagerId: project?.managerId,
        IsValid: true,
        Name: x.name,
        managerComments: managerComments && managerComments.comments ? managerComments.comments : '',
        AttendanceData: this.formEmptyAttendanceData()
      };
    }));
    this.GetAttendanceTableHeader();
    this.filterOptionsList = this.attendanceTableHeader.map(y => {
      if (!y.Children) {
        return {
          Name: y.Name,
          IsSelectedAll: false,
          FilterOptions: y.DropDownValues.reduce((acc, val) => acc.concat(val), []).map(x => { return { optionValue: x, isSelected: false } })
        }
      }
    }).filter(p => p);

    this.ListOfEmpAttendance = this.empAttendanceList;
  }

  async uploadExcelFile() {
    this.selectedEmployeesLeaveData = [];
    this.buildempAttendanceList();
    this.uploading = true;
    try {
      this.AttedanceData = this.AttedanceData.filter(x => x.status != "Weekly Off");
      this.AttedanceData.map(row => {
        if (this.dateFormat(row.date).toString() != "Invalid Date") {
          const employees = this.empAttendanceList.filter(x => x.EmpId == row.employeeId);
          employees.forEach(emp => {
            emp.AttendanceData.forEach(x => {
              x.Days.forEach(y => {
                if (x.PSHours == undefined) {
                  x.PSHours = 0
                }
                if (y.date == row.date && !y.checked) {
                  y.checked = true;
                  if (row.status == "Present") {
                    x.Status = "present_in_ps";
                    x.PSHours = x.PSHours + 8;
                    x.TEHours = 0;
                  } else if (row.status == "HalfDay Leave") {
                    x.Status = "present_in_ps";
                    x.PSHours = x.PSHours + 4;
                    x.TEHours = 0;
                  } else if (row.status == "Half Day") {
                    x.Status = "present_in_ps";
                    x.PSHours = x.PSHours + 4;
                    x.TEHours = 0;
                  } else if (row.status == "Maternity Leave") {
                    x.Status = "Maternity Leave";
                    x.PSHours = 0;
                    x.TEHours = 0;
                  } else if (row.status == "Paternity Leave") {
                    x.Status = "Paternity Leave";
                    x.PSHours = 0;
                    x.TEHours = 0;
                  } else {
                    x.Status = "present_in_ps";
                    x.PSHours = x.PSHours + 0;
                    x.TEHours = 0;
                  }
                }
                if (this.compareDatesOnly(new Date(y.date), this.dateFormat(row.date))) {
                  y.psHours = this.getPSHours(row.status);
                }
              });
            });
          });
        }
      });            
      let startdate = this.datePipe.transform(this.start_date, 'yyyy-MM-dd');
      let enddate = this.datePipe.transform(this.end_date, 'yyyy-MM-dd');
      this.service.getEmployeeLeaveDatawithEmployeeIds(this.selectedEmployees.map(x => x.id), startdate, enddate).subscribe(data => {
        this.selectedEmployeesLeaveData = data.data;
        this.selectedEmployeesLeaveData.map(x => {
          const [year, month, day] = x.date.split('-');
          const modifiedTimesheetDate = new Date(x.date);
          const currentEmployees = this.empAttendanceList.filter(y => y.EmpId == x.employeeId);
          if (currentEmployees.length > 0) {
            currentEmployees.forEach(currentEmployee => {
              currentEmployee.AttendanceData.forEach(z => {
                z.Days.forEach(a => {
                  if (this.compareDatesOnly(new Date(a.date), modifiedTimesheetDate)) {
                    a.TandEHours = x['actualHours'];
                    a.PeopleStrongHours = x['expectedHours'];
                    if (x['mismatch'] > 0) {
                      a.mismatchHours = x['mismatch'];
                    } else {
                      a.mismatchHours = 0;
                    }
                  }
                  // var data = this.compareDatesOnly(new Date(a.date), this.toDateObject(x.fromDate))
                  // if (data && z.Status == "present_in_ps") {
                  //   a.teHours = x.hours;
                  //   z.TEHours += parseFloat(x.hours);
                  // }
                  // if (data && z.Status == "present_in_ps" && a.psHours != null) {
                  //   if (a.psHours != parseFloat(x.hours)) {
                  //     a.valid = false;
                  //   }
                  // }
                });
                const noMismatch = z.Days.every(day => !day.mismatchHours);
                if (noMismatch) {
                  z.Status = 'match';
                } else {
                  z.Status = 'mismatch';
                  z['TandEHours'] = z.Days.reduce((acc, item) => acc + (item.TandEHours || 0), 0);
                  z['PeopleStrongHours'] = z.Days.reduce((acc, item) => acc + (item.PeopleStrongHours || 0), 0);
                  z['mismatchHours'] = z.Days.reduce((acc, item) => acc + (item.mismatchHours || 0), 0);
                }
              });
              const isMimatchFound = currentEmployee.AttendanceData.some((data) => data.Status === 'mismatch');
              if (isMimatchFound) {
                currentEmployee.IsValid = false;
              }
            });
          } else {
            this.empAttendanceList.forEach(currentEmployee => {
              if (currentEmployee.EmpId == x.employeeId) {
              currentEmployee.AttendanceData.forEach(x => {
                  x.Status = "not_present_in_ps";
                });
              }
            });
          }
        })
        // this.empAttendanceList = this.empAttendanceList.filter(x => x.AttendanceData.filter(y => {
        //   if (y.PSHours != undefined && y.TEHours != undefined && y.PSHours > 0 && y.TEHours > 0) {
        //     if (y.TEHours == y.PSHours) {
        //       y.Status = "match"
        //       if (x.IsValid != false) {
        //         x.IsValid = true
        //       }
        //     }
        //     else {
        //       y.Status = "mismatch"
        //       x.IsValid = false;
        //     }
        //   }
        // }))
        this.dataInExcel = true;
 
        const mismatchedData = this.empAttendanceList.filter(employee => {
          return employee.AttendanceData?.some(day => day.Status === "mismatch");
        });
        if (mismatchedData.length > 0) {
          this.actionCOunt = mismatchedData.length;
          let response: any = [];
          mismatchedData.forEach(x => {
            let index = response?.findIndex(y => y.projectName === x.ProjectName);
            if (index < 0) {
              response.push({
                projectName: x.ProjectName,
                count: 1
              })
              this.differProjectCount += 1
            }
            else {
              response[index].count += 1;
            }
          }
          )
        }
        const matchedData = this.empAttendanceList.filter(employee => {
          return employee.AttendanceData?.every(day => day.Status !== "mismatch");
        });
        // Concatenate mismatched and matched data (avoid duplicates)
        const deduplicatedMismatchedData = Array.from(new Set(mismatchedData));
        const reorderedData = [...deduplicatedMismatchedData, ...matchedData];
        this.empAttendanceList = reorderedData;
        this.empAttendanceListForPMO = JSON.parse(JSON.stringify(reorderedData)); // Deep copy to avoid mutation
        const uniqueRecords = new Map();
        this.empAttendanceList.forEach(record => {
        const key = record.EmpId;
        if (!uniqueRecords.has(key)) {
        uniqueRecords.set(key, record);}});
        this.empAttendanceList.length = 0; 
        this.empAttendanceList.push(...Array.from(uniqueRecords.values()));
        const projectNames = this.empAttendanceList.map((item) => item.ProjectName);
        this.totalProjectCount = [...new Set(projectNames)].length;
        this.empAttendanceList.forEach((emp) => {
          emp['mappedChildrenData'] = this.getChildrenData(emp);
        });
        this.ListOfEmpAttendance = this.dataMapping(this.empAttendanceList.filter(x => x.IsValid == false));
        if(!this.submitClicked && localStorage.getItem("timesheetManager") && !this.isPMORole){
          this.getdataforpiechart();
        }
        if (this.submitClicked && this.isPMORole && this.isManagerOrSuperAdmin) {
          this.getpiechartdataforPMORole();
        }
        if(!this.submitClicked && localStorage.getItem("timesheetManager") && !this.isPMORole){
          this.getdataforpiechart();
        }
        if (this.submitClicked && this.isPMORole && this.isManagerOrSuperAdmin) {
          this.getpiechartdataforPMORole();
        }
      });
    } catch (error) {
      console.error('Error parsing Excel file:', error);
    }
    this.uploading = false;
  }

  getTotalProjectCount() {
    const projects = this.filterOptionsList.find((item) => item.Name === 'Project Name');
    return projects && projects.FilterOptions ? projects.FilterOptions.length : 0;
  }

  getPSHours(data) {
    if (data == "HalfDay Leave") {
      return 4;
    }
    else if (data == 'Half Day') {
      return 4;
    }
    else if (data == 'Present') {
      return 8;
    }
    else {
      return 0;
    }
  }


  formatDate1(dateString) {
    // Split the date string into components (day, month, year, optional time)
    const parts = dateString.split(' ');
    const datePart = parts[0];
    const timePart = parts.length > 1 ? parts[1] : null;
    var year = null;
    var month = null;
    var day = null;

    // Split the date part (day-month-year)
    const dateComponents = datePart.split('-');
    if (dateComponents.length > 1) {
      year = dateComponents[2];
      month = String(parseInt(dateComponents[1], 10)).padStart(2, '0'); // Add leading zero for single-digit months
      day = String(parseInt(dateComponents[0], 10)).padStart(2, '0'); // Add leading zero for single-digit days

    }
    else {
      const datecomponent = datePart.split('/');
      year = datecomponent[2];
      month = String(parseInt(datecomponent[0], 10)).padStart(2, '0'); // Add leading zero for single-digit months
      day = String(parseInt(datecomponent[1], 10)).padStart(2, '0'); // Add leading zero for single-digit days


    }

    // Format the date in yyyy-mm-dd
    return `${year}-${month}-${day}`;
  }
  dateFormat(dateString): Date {
    const parts = dateString.split('-');
    const day = parseInt(parts[2], 10);
    const month = parseInt(parts[1], 10) - 1; // Months are zero-based (0 = January)
    const year = parseInt(parts[0], 10);
    return new Date(year, month, day);

  }
  formatDate(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const year = date.getFullYear();

    // Pad single-digit day and month with leading zeros
    const formattedDay = day.toString().padStart(2, '0');
    const formattedMonth = month.toString().padStart(2, '0');

    return `${year}-${formattedMonth}-${formattedDay}`;
  }



  onFileSelected(event: any) {
    this.file = event.target.files[0];

    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.selectedFileName = file.name;
    }
  }

  getPOCByProjectIds(searchkey: string) {
    if (this.selectedProjects.length != 0) {
      this.service.getPointofContactName(this.selectedProjects,this.formatDate(new Date(this.start_date)), this.formatDate(new Date(this.end_date)), searchkey).subscribe(
        (response: any) => {
          this.storePointofContactsNames = response.data;
          this.storePointofContactsNamesAll = response.data;
          if (!this.timesheetAdmin) {
            this.toggleSelectAllEmployees();
          }

          this.isAllVisibleChecked("employee");
        },
        (error) => {
        }
      );
    }
    else {
      this.storePointofContactsNames = [];
      this.storePointofContactsNamesAll = [];
    }
  }

  getProjectManagersName() {
    this.service.getManagersList().subscribe(
      (response: any) => {
        this.storeProjectManagerNames = response;
      });
  }

  getprojectNameByManagerIds(searchkey?: any) {

    if (this.selectedManagers.length != 0) {
      this.service.getProjectsByManagerId(this.selectedManagers.map(x => x.employeeId), searchkey).subscribe(
        (response) => {
          this.projectnames = response.data;
          const uniqueProjectNames = new Set();
          this.projectnames.forEach(record => {
          uniqueProjectNames.add(record.name);});
          this.uniqueProjectNamesArray = Array.from(uniqueProjectNames);
          this.projectnamesall = response.data;
          this.projectnames.forEach(element => {
            const data = {
              id: element.id,
              managerid :element.managerId
            }
            this.selectedProjects.push(data);

          });
          this.getPOCByProjectIds('');
        },
        (error) => {
        }
      );
    }
    else {
      this.projectnames = [];
    }
  }
  formatSelectedText(length: number) {
    return length > 1 ? `and ${length - 1} more` : ""
  }
  async openComment(data: EmployeeAttendanceModel) {
    const EmployeeId = parseInt(data.EmpId);
    const employeeName = data.Name;
    const ProjectId = this.storePointofContactsNames.find(x => x.id == EmployeeId)?.parentId;
    const Email = this.storePointofContactsNames.find(x => x.id == EmployeeId)?.email;
    const Projectname = this.projectnames.find(x => x.id == ProjectId)?.name;
    const MangerId = this.projectnames.find(x => x.id == ProjectId)?.reportingTo;
    const managerName = this.storeProjectManagerNames.find(x => x.employeeId == MangerId)?.name;
    this.dialogRef = this.dialog.open(this.infoDialog,
      {
        height: auto, width: auto,
        minWidth: '450px', data: { employeeName: employeeName, projectName: Projectname, managerName: managerName, Email: Email }
      });
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // const mismatchData = data.AttendanceData?.filter(x => x.Days.find(x => x.valid == false));
        // mismatchData.filter(x => x.Days.forEach(y => {
        //   if (y.valid == false) {
        //     this.mismatchDates?.push(this.formatDate(new Date(y.date)));
        //   }
        // }));
        const managerEmpId = parseInt(localStorage.getItem('Id'));
        const apiData = {
          managerEMPId: managerEmpId,
          senderEMPId: EmployeeId,
          comments: this.commentToMail,
          dates: this.mismatchDates,
          startDate: this.start_date,
          endDate: this.end_date,
          projectId: ProjectId
        }
        this.service.sendMail(apiData).subscribe((response) => {
          this.toster.success("Successfully send a mail");
          this.commentToMail = null;
          this.mismatchDates = null;
        },
          (error) => {
            this.toster.error("Mail is not send ");
            this.commentToMail = null;
            this.mismatchDates = null;
          })
      }
    });

  }
  submit() {
    this.dialogRef.close(true);
  }
  close() {
    this.dialogRef.close(false);
    this.commentToMail = null;
    this.mismatchDates = null;
  }

  openLineChartDialog() {
    this.empIdList = ['104024', '105157'];
    this.dialog.open(LinechartDialogComponent, {
      width: '100%',
      height: auto,
      data: {
        empId: this.empIdList,
        empName: this.selectedEmployees,
        projectName: this.projectnames
      }
    });
  }
  filterWithWidgetIcons(data: any) {
    if (data == "mismatch") {
      const data = this.empAttendanceList.filter(x => x.IsValid == false);
      this.ListOfEmpAttendance = this.dataMapping(data);
    }
    else if (data == "match") {
      const data = this.empAttendanceList.filter(x => x.IsValid == true);
      const matches = data.filter(employee => {
        return employee.AttendanceData?.every(day => day.Status == "match");
      });
      const Unmatches = data.filter(employee => {
        return employee.AttendanceData?.some(day => day.Status == "mismatch" || day.Status == 'not_present_in_ps' || day.Status == 'resent_in_ps');
      });
      const deduplicatedMismatchedData = Array.from(new Set(matches));
      const reorderedData = [...deduplicatedMismatchedData, ...Unmatches];
      this.ListOfEmpAttendance = this.dataMapping(reorderedData);
    }
    else {
      this.ListOfEmpAttendance = this.dataMapping(this.empAttendanceList);
    }

  }
  dataMapping(data) {
    const deliveryManagerColumnChecked = {};
    const projectNameColumnChecked = {};
    const datatable = data.sort((a, b) => {
      const taskComparator = a.DeliveryManager.localeCompare(b.DeliveryManager);
      return taskComparator
        ? taskComparator
        : a.ProjectName.localeCompare(b.ProjectName);
    })
      .map((x) => {
        const deliveryManagerColumnSpan = deliveryManagerColumnChecked[x.DeliveryManager]
          ? 0
          : data.filter((y) => y.DeliveryManager === x.DeliveryManager).length;

        deliveryManagerColumnChecked[x.DeliveryManager] = true;

        const projectNameColumnSpan =
          projectNameColumnChecked[x.DeliveryManager] &&
            projectNameColumnChecked[x.DeliveryManager][x.ProjectName]
            ? 0
            : data.filter(
              (y) => y.DeliveryManager === x.DeliveryManager && y.ProjectName === x.ProjectName
            ).length;

        projectNameColumnChecked[x.DeliveryManager] =
          projectNameColumnChecked[x.DeliveryManager] || {};
        projectNameColumnChecked[x.DeliveryManager][x.ProjectName] = true;
        return { ...x, deliveryManagerColumnSpan, projectNameColumnSpan };
      });
    return datatable
  }
  exportData() {
    const flattenedHeaders = [];
    const flattenedHeadersPropKeys = [];


    this.attendanceTableHeader.forEach(header => {
      if (header.Children && header.Children.length > 0) {
        header.Children.forEach(child => {
          flattenedHeaders.push(`${header.Name} - ${child.Label}`);
          flattenedHeadersPropKeys.push(child.Label);
        });
      } else {
        flattenedHeaders.push(header.Name);
        flattenedHeadersPropKeys.push(header.PropKey);
      }
    });
    flattenedHeaders.splice(2, 0,'Project Manager', 'Employee ID');
    flattenedHeadersPropKeys.splice(2, 0, 'EngineeringManager', 'EmpId');

    const dataRows = this.ListOfEmpAttendance.map(att => {
      const row = [];
      let attendanceData = att['AttendanceData'];
      flattenedHeadersPropKeys.forEach((header, index) => {
        const headerParts = header.split(' - ');
        if (headerParts.length > 1) {
          let resValue = attendanceData?.find(x => x.Label == header);
          if (resValue.Status == 'match' || resValue.Status == 'mismatch') {
            row.push({
              value: resValue.Status === 'mismatch' 
                // ? `Status: ${resValue.Status}. People Strong: ${resValue['PeopleStrongHours']} hrs.<br>T&E: ${resValue['TandEHours']} hrs.<br>Diff: ${resValue['mismatchHours']} hrs.`
                ? `Status: ${resValue.Status}.\nPeople Strong: ${resValue['PeopleStrongHours']} hrs.\nT&E: ${resValue['TandEHours']} hrs.\nDiff: ${resValue['mismatchHours']} hrs.`
                : `Status: ${resValue.Status}`,
              status: resValue.Status
            });
          } else {
            row.push({
              value: "Status: " + resValue.Status,
              status: resValue.Status
            });
          }
        } else {
          row.push({
            value: att[header] ? `${att[header]}` : '',
            status: null
          });
        }
      });
      return row;
    });

    const worksheetData = [flattenedHeaders, ...dataRows.map(row => row.map(cell => cell.value))];


    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);


    const columnWidths = this.getColumnWidths(flattenedHeadersPropKeys);
    worksheet['!cols'] = columnWidths;


    flattenedHeaders.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
      if (!worksheet[cellAddress]) worksheet[cellAddress] = { t: 's', v: header };
      worksheet[cellAddress].s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "FFFF00" }
        },
        font: {
          bold: true
        }
      };
    });

    dataRows.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex });
        if (!worksheet[cellAddress]) worksheet[cellAddress] = { t: 's', v: cell.value };
        let fillColor = null;
        switch (cell.status) {
          case 'match':
            fillColor = '00FF00';  // Green
            break;
          case 'mismatch':
            fillColor = 'FF0000';  // Red 
            break;
          case 'present_in_ps':
            fillColor = '00FFFF';  // Cyan 
            break;
          case 'Maternity Leave':
            fillColor = 'FF00FF';  // Magenta 
            break;
          case 'not_present_in_ps':
            fillColor = 'FFA500';  // Orange 
            break;
          default:
            if (cell.status) {
              fillColor = 'C0C0C0';  // Grey 
            }
        }
        if (fillColor) {
          worksheet[cellAddress].s = {
            fill: {
              patternType: "solid",
              fgColor: { rgb: fillColor }
            }
          };
        }
      });
    });

    if (this.ListOfEmpAttendance.length > 0){
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'TimeSheetData');
      XLSX.writeFile(workbook, 'TimeSheetData.xlsx');
    } else {
      this.toster.error('No data available for export');
    }

  }
  getColumnWidths(headers) {
    return headers.map(header => {
      let width = 0;
      const headerParts = header.split(' - ');
      if (headerParts.length > 1) {
        width = 45;
      } else {
        width = 20;
      }
      return { width };
    });
  }

  openManagerCommentsPopup(att) {
    this.initialDialogComment = att.managerComments || '';
    this.dialogManagerComment = this.initialDialogComment;
    const Email = this.storePointofContactsNames.find(x => x.id == att.EmpId)?.email
    const dialogRef = this.dialog.open(this.commentsDialog);

    dialogRef.afterClosed().subscribe((data: string) => {
      if (data) {
        const params = {
          parentId: att.EmpId,
          name: att.Name,
          email: Email,
          managerId: att.ManagerId,
          comments: data,
        };
        
        this.service.saveTimesheetComments(params).subscribe((res) => {
          this.reloadManagerComments()
        }, (err) => {
          this.toster.error("Error occured while saving comments.")
        });
      }
      this.dialogManagerComment = '';
      this.initialDialogComment = '';
    });
  }

  reloadManagerComments() {
    this.service.getManagerCommentForEmployees().subscribe((res) => {
      this.commentsForMultipleProjects = res.data;
      this.differProjectCount = 0;
      this.uploadExcelFile();
    });
  }

}